const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

function getFormattedDate(date, prefomattedDate = false, hideYear = false) {
  const day = date.getDate();
  const month = MONTH_NAMES[date.getMonth()];
  const year = date.getFullYear();
  
  let hours = date.getHours();
  let minutes = date.getMinutes();

  let ampm = "am";
  if (hours > 12) {
    hours -= 12;
    ampm = "pm";
  }

  if (minutes < 10) {
    // Adding leading zero to minutes
    minutes = `0${ minutes }`;
  }

  return `${ day } ${ month } ${ hours }:${ minutes }${ ampm }`;
}

export function timesAgo(dateParam) {
  if (!dateParam) {
    return null;
  }

  const date = typeof dateParam === 'object' ? dateParam : new Date(dateParam);
  const now = new Date();
  const seconds = Math.round((now - date) / 1000);
  const minutes = Math.round(seconds / 60);
  const hours = Math.round(minutes / 60);
  const days = Math.round(hours / 24);
  const weeks = Math.round(days / 7);
  const months = Math.round(days / 30.44); // average month length
  const years = Math.round(days / 365.25);

  if (seconds < 5) {
    return 'now';
  } else if (seconds < 60) {
    return `${seconds} sec ago`;
  } else if (seconds < 90) {
    return '1 min ago';
  } else if (minutes < 60) {
    return `${minutes} min${minutes === 1 ? '' : 's'} ago`;
  } else if (hours < 24) {
    return `${hours} hr${hours === 1 ? '' : 's'} ago`;
  } else if (days < 7) {
    return `${days} day${days === 1 ? '' : 's'} ago`;
  } else if (weeks < 5) {
    return `${weeks} wk${weeks === 1 ? '' : 's'} ago`;
  } else if (months < 12) {
    return `${months} mo${months === 1 ? '' : 's'} ago`;
  } else if (years === 1) {
    return '1 yr ago';
  } else {
    return `${years} yrs ago`;
  }
}